export var CP_GO_URL_REGEX = /^(\/try)?\/go($|\/)/;
export var CP_GO_URL_FAQ = 'https://help.classpass.com/hc/en-us/categories/360000743812-ClassPass-Go';